import createRandomColorViaHSL from "../utils/createRandomColor";

function feedbacks(commonWrapperSelector, btnAttrSelector, btnDisableClass, feedbacks) {
    const feedbacksCommonWrapper = document.querySelector(commonWrapperSelector),
          moreFeedbacksBtn = document.querySelector(btnAttrSelector);
   
    let start = 0,
        end = 0;
    let visibleFeedbacks = feedbacks.slice(start, end);

        
    function showVisibleFeedbacks() {
        visibleFeedbacks.forEach(feedback => {
            const isGoogle = feedback.source === 'Google';
            const feedbackWrapper = document.createElement('div');
            feedbackWrapper.classList.add('col-12', 'col-md-6', 'col-xl-4');
            feedbackWrapper.innerHTML = `
            <div class="comment">
            <div class="comment__wrapper1">
                <div 
                    class="comment__letter"
                    style="background-color: ${createRandomColorViaHSL()}">
                    ${feedback.name.slice(0, 1)}
                </div>
                <div class="comment_shell">
                    <div class="comment__name">${feedback.name}</div>
                    <div class="comment__date">${feedback.data}</div>
                </div>
            </div>
            <div class="comment__wrapper2">
                <img src="icons/feedback/stars.svg" alt="stars">
            </div>
            ${feedback.source ? `
                <div class="comment__source">
                    <span class="comment__source-icon ${isGoogle ? 'comment__source-icon_google' : ''}">${isGoogle ? 'G' : 'Я'}</span>
                    <span>Отзыв из ${feedback.source}</span>
                </div>
            ` : ''}
            <div class="comment__wrapper3">${feedback.description}</div>
            </div>
            `;
            feedbacksCommonWrapper.append(feedbackWrapper);
        });
    }
    // showVisibleFeedbacks();

    function loadMoreFeedbacks() {
        start = end;
        end += 6;
        visibleFeedbacks = feedbacks.slice(start, end);
        showVisibleFeedbacks();

        if (end >= feedbacks.length) {
            moreFeedbacksBtn.removeEventListener('click', loadMoreFeedbacks);
            moreFeedbacksBtn.classList.add(btnDisableClass);
            moreFeedbacksBtn.disabled = true;
        }
        moreFeedbacksBtn.blur();
    }

    moreFeedbacksBtn.addEventListener('click', loadMoreFeedbacks);

}

export default feedbacks;